// Register.jsx
import React, { useEffect } from "react";
import { Container, Paper, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RegisterForm from "../components/Auth/RegisterForm";
import useAuth from "../hooks/useAuth";

function Register() {
	const { user } = useAuth();
	const navigate = useNavigate();

	// Redirect to dashboard if already logged in
	useEffect(() => {
		if (user) {
			navigate("/");
		}
	}, [user, navigate]);

	return (
		<Box
			sx={{
				height: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				bgcolor: "#f8f9fa",
			}}
		>
			<Container maxWidth="sm">
				<Paper
					sx={{
						p: 4,
						borderRadius: 2,
						boxShadow: 3,
					}}
				>
					<Box sx={{ textAlign: "center", mb: 4 }}>
						<Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
							Discord Bot Platform
						</Typography>
						<Typography variant="body1" color="text.secondary">
							Create a new account
						</Typography>
					</Box>
					<RegisterForm />
				</Paper>
			</Container>
		</Box>
	);
}

export default Register;
